export const PATTERNS_GROUP_NAME = 'Patterns'

export const PATTERN_SUBCATEGORY_CHART = 'Chart Patterns'
export const PATTERN_SUBCATEGORY_CANDLESTICK = 'Candlestick Patterns'

export const PATTERN_SUBCATEGORIES = [
    PATTERN_SUBCATEGORY_CHART,
    PATTERN_SUBCATEGORY_CANDLESTICK,
] as const

export type PatternSubcategory = (typeof PATTERN_SUBCATEGORIES)[number]
